'use strict';

const _ = require('lodash');
const jQuery = require('jquery');

const pluginUploader = require('./../../plugin/upload');

const Container = require('./../../../../core/container');
const DndZone = require('../dndZone');

const tpl = require('./template/placeholder.hbs');

const insertPlaceholder = function(images) {
  let placeholder = tpl();

  _.forEach(images, function(contentImage) {
    let $image = jQuery(contentImage);
    let img = $image.find('img');

    if ((Container.get('isMobile') && false === $image.data('mobile-edit')) ||
      $image.find('.cloud-placeholder').length > 0) {
      return;
    }

    if (!img.attr('src')) {
      img.parent().remove();
      $image.addClass('has-image-placeholder').prepend(placeholder);
    }
  });

  DndZone.apply();
};

module.exports.onContentClick = function(content) {
  if (content.$.find('.cloud-placeholder').length) {
    pluginUploader.onClick(content);
  }
};

module.exports.apply = function(image) {
  if (image.$ instanceof jQuery) {
    insertPlaceholder(image.$);
  }
};

module.exports.init = function() {
  insertPlaceholder(jQuery('.media-image'));
};
